import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IAdminFeesMerchant } from '../types';
import {
  AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_API_URL,
  AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_QUERY_KEY,
  AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS,
} from '../constants';

export default function useAdminFeesMerchantsQuery(): IContextQueryResult<IAdminFeesMerchant[]> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAdminFeesMerchant[]>({
    queryKey: [AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAdminFeesMerchant[]>(
      AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_API_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS.SHOW,
      },
    ),
  });
}
